import React from 'react';

const ContactLink = () => {
  return (
    <div className="contact-container">
      <p>
        Se precisar de ajuda, entre em contato com nosso suporte através do e-mail: 
        <a href="mailto:suporte@lotopim.com.br"> suporte@lotopim.com.br</a>
      </p>
    </div>
  );
};

export default ContactLink;
